import api from "./api";

export const getBadges = (page, params) => {
  return api.get("admin/Badge", { params: { page: page, limit: 5, ...params} });
};

export const createBadge = ({sqlCheck, sqlCheckProgress, untilDate, startDate, limit, name, i18n, badgeUrl}) => {
  return api.post("admin/badge", { sqlCheck, sqlCheckProgress, untilDate, startDate, limit, name, i18n, badgeUrl });
};

export const updateBadge = (uid, { untilDate, startDate, limit, name, i18n, badgeUrl}) => {
  return api.put(`admin/badge/${uid}`, { untilDate, startDate, limit, name, i18n, badgeUrl});
};

export const enableBadge = (uid, enabled) => {
  return api.post(`admin/badge/${uid}/enable`, { enabled });
};

export const approveBadge = (uid, approved) => {
  return api.post(`admin/badge/${uid}/approval`, { approved });
};

export const getBadgesBySearch = (searchItem, search) => {
  return api.get(`admin/Badge?searchItem=${searchItem}&search=${search}`);
};
    
export const getBadgesByOrder = (item, direction) => {
  return api.get(`admin/Badge?order=${item}&direction=${direction}`);
};

export const getBadgeWinners = (uid, page) => {
  return api.get(`admin/badge/${uid}/winners`, { page: page });
};